import { SDKProtocol } from '@chat/utils';
import { copy } from '@chat/utils/lib/utils';
import { closechat } from '@/redux/im/action';
import store from '@/redux/index';
import { ImState } from '@/typings/reducer';
import { IMSTATUS } from '@/config/enum';

const { getState, dispatch } = store;
type SyncStage = ImState['stage'] | 3;

class SDKServer extends SDKProtocol {
    private observedStage: SyncStage;

    private notifiedStage?: SyncStage;

    private notifiedSessionId?: string;

    private getSyncStage = (): SyncStage => {
        const { stage, STATUS } = getState().IMReducer;
        return STATUS?.status === IMSTATUS.ENDED ? 3 : stage;
    };

    constructor() {
        super();
        this.observedStage = this.getSyncStage();
        store.subscribe(() => {
            this.syncSession();
            const stage = this.getSyncStage();
            if (stage === this.observedStage) {
                return;
            }
            this.observedStage = stage;
            this.syncStage(stage);
        });
    }

    /** 同步当前客服阶段给业务；相同阶段不重复通知。 */
    syncStage = (stage: SyncStage = this.getSyncStage()): number => {
        if (stage === this.notifiedStage) {
            return 1;
        }
        try {
            const result = super.syncStage(stage);
            if (result === 1) {
                this.notifiedStage = stage;
            }
            return result;
        } catch (error) {
            console.error('[IMBridge] 客服阶段同步失败：', stage, error);
            return 0;
        }
    };

    /** 同步有效会话 ID；未实现或调用失败时保留后续补发机会。 */
    syncSession = (): number => {
        const { sess_id } = getState().IMReducer;
        if (!sess_id || sess_id === '0') {
            this.notifiedSessionId = undefined;
            return 0;
        }

        const sessionKey = String(sess_id);
        if (sessionKey === this.notifiedSessionId) {
            return 1;
        }
        try {
            const result = super.syncSession({ sess_id });
            if (result === 1) {
                this.notifiedSessionId = sessionKey;
            }
            return result;
        } catch (error) {
            console.error('[IMBridge] 客服会话同步失败：', { sess_id }, error);
            return 0;
        }
    };

    DomClick = (event: any): void => {
        const {
            // localName标签名称
            target: { localName }
        } = event;
        const swiper = {
            // a标签在客户端内打开情况
            a: () => this.clickAnchor(event),
            default: () => {}
        };
        return swiper?.[localName]?.() || swiper.default();
    };

    downloadFile = (type, event, down_url, file_url, file_name, file_ext): number => {
        const res = super.downloadFile(type, event, down_url, file_url, file_name, file_ext);
        if (res === -2) {
            copy(down_url);
        }
        if (res === 0) {
            IM.IMServer.notice('error', '文件下载事件未实现');
        }
        return res;
    };

    clickAnchor = (event, isCurrent = false): number => {
        const res = super.clickAnchor(event, isCurrent);
        if (res === 0) {
            IM.IMServer.notice('error', '链接点击事件未实现');
        }
        return res;
    };

    closeWebView = (): number => {
        const res = super.closeWebView();
        if (res === 0) {
            IM.IMServer.notice('error', '关闭webView事件未实现');
        }
        return res;
    };

    openNewWindow = (url, title, mini_url): number => {
        const res = super.openNewWindow(url, title, mini_url);
        if (res === 0) {
            IM.IMServer.notice('error', '打开新窗口事件未实现');
        }
        return res;
    };

    closeByWindow = async (quit): Promise<void> => {
        const { stage } = getState().IMReducer;
        if (stage === 0) {
            return;
        }
        await closechat(quit)(dispatch, getState);
    };

    exitConfirm(function_name: any): number {
        const res = super.exitConfirm(function_name);
        if (res === 0) {
            IM.IMServer.notice('error', '退出拦截事件未实现');
        }
        return res;
    }

    exitWebViewConfirm = (): number => {
        const { stage } = getState().IMReducer;
        if (stage === 0) {
            this.exitConfirm('');
            this.closeWebView();
            return 0;
        }
        IM.handlePopup({ popup: 'notice', open: false });
        IM.handlePopup({ popup: 'evaluate', open: false });
        IM.handlePopup({ popup: 'closeWebView', open: true });
        return 1;
    };

    openImgViewer(list, index): number {
        const res = super.openImgViewer(list, index);
        return res;
    }
}
export default SDKServer;
